<mat-spinner [diameter]="20"></mat-spinner>
{{ message }}
